import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import '../App.css';

const ContactForm = ({ onSuccess }) => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        message: ""
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(
                "https://tattvarealty.co.in/backend-files/one-by-msn/contact-tattva.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    body: new URLSearchParams(formData).toString()
                }
            );

            const result = await response.json();

            if (result.status === "success") {
                onSuccess?.();               // close modal if exists
                navigate("/thank-you");      // redirect after success
            } else {
                alert(result.message || "Something went wrong. Please try again.");
            }
        } catch (error) {
            console.error("Form Error:", error);
            alert("Server error. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <motion.form
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            onSubmit={handleSubmit}
        >
            <input
                className="form-control mb-3"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
            />

            <input
                className="form-control mb-3"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
            />

            <input
                className="form-control mb-3"
                name="email"
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
            />

            <textarea
                className="form-control mb-3"
                name="message"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
            />

            <button
                className="btn bg-cream border-0 w-100"
                type="submit"
                disabled={loading}
            >
                {loading ? "Submitting..." : "Submit"}
            </button>

            {/* DIVIDER */}
            <div className="d-flex justify-content-center my-4">
                <div
                    style={{
                        width: "80%",
                        height: "1px",
                        backgroundColor: "rgba(255,255,255,0.6)",
                    }}
                />
            </div>
        </motion.form>
    );
};

export default ContactForm;
